//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import LocaleSwitcher from "@/components/LocaleSwitcher";
import AvareNumeric from "@/components/avareNumeric";
import { mapState } from "vuex";

export default {
  name: "NumericClean",
  props: ["label", "tabindex", "numericvalue", "disabled", "readonly", "suffix", "numberofdecimals"],
  components: { AvareNumeric },

  data() {
    return { numberDecimal: 0 };
  },

  computed: { ...mapState("main", ["company"]) },
  methods: {
    updateVal(newVal) {
      var parsedVal = null;
      if (newVal) parsedVal = parseFloat(newVal.replace(",", "."));
      if (parsedVal % 1 != 0) {
        var decimal = parsedVal
          .toString()
          .split(".")[1]
          .substring(0, this.numberDecimal);
        var beforeDecimal = parsedVal.toString().split(".")[0];
        var combined = beforeDecimal + "." + decimal;
        parsedVal = parseFloat(combined);
      }

      if (isNaN(parsedVal)) parsedVal = null;
      this.$emit("update:numericvalue", parsedVal);
      this.$emit("onChange", parsedVal);
    },
  },
  async mounted() {
    // GET request using fetch with error handling
    if(!this.numberofdecimals) {
      this.numberDecimal = parseInt(this.company.showNumberOfDecimals);
    }
    else {
      this.numberDecimal = this.numberofdecimals
    }
    
  },
};
